<ng-container *ngIf="isAgainstRecommendation && !showGuidedBfProg; else showbfProgSelection">
    <!-- Against Recommendation Screen -->
    <div class="flex-modal-wrapper">
        <div class="modal-row">
            <p>Typically, people in your age group do not require Bifocal or Progressive Lenses</p>
            <h5>Are you sure you want <span class="text-blue"><b>Bifocal or Progressive Lenses</b></span> ?</h5>
        </div> 
        <div class="modal-row">        
            <div class="modal-col">
                <span>Bifocal/Progressive</span>
                <img src="assets/images/icons/arrow-up.svg" class="guided-opt-arrow" alt="Arrow Icon">
                <button type="button" class="btn gray-btn" (click)="onAcceptedWarning()">Yes</button>
            </div>        
            <div class="modal-col">
                <span>Single Vision</span>
                <img src="assets/images/icons/arrow-up.svg" class="guided-opt-arrow" alt="Arrow Icon">
                <button type="button" class="btn gray-btn" (click)="showSingleVision()">No</button>
            </div>
        </div>
    </div>
    <!-- Against Recommendation Screen -->
</ng-container>
<ng-template #showbfProgSelection>
    <!-- Bifocal / Progressive Selection Screen -->
    <ng-container *ngIf="!showConfirmLined && !showProgressiveOptions">
        <div class="modal-row">
            <h5>Select the lens style you normally wear</h5>    
            <img src="../../../../assets/images/guided-opt/lined-vs-no-line.png" class="bf-prog-full">
        </div>
        <div class="modal-row">
            <div class="modal-col">
                <img src="../../../../assets/images/guided-opt/lined-bf.png" class="lined-bf">
                <img src="assets/images/icons/arrow-up.svg" class="guided-opt-arrow" alt="Arrow Icon">
                <button type="button" class="btn gray-btn" (click)="showConfirmLined=true">Lined Bifocal</button>
            </div>        
            <div class="modal-col">
                <img src="../../../../assets/images/guided-opt/progressive.png" class="prog">
                <img src="assets/images/icons/arrow-up.svg" class="guided-opt-arrow" alt="Arrow Icon">
                <button type="button" class="btn gray-btn" (click)="showProgressives()">No Line Progressive</button>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="showConfirmLined">
        <div class="flex-modal-wrapper">
            <div class="modal-row">
                <h5>With a <strong>LINED</strong> bifocal, this is what you would see</h5>
                <img src="../../../../assets/images/guided-opt/lined-bifocal-confirm.png" class="guided-img-lg">
                <h5>Would you like to eliminate the line?</h5>     
            </div>
            <div class="modal-row">
                <div class="modal-col">
                    <button type="button" class="btn gray-btn" (click)="showProgressives()">Yes</button>
                </div>        
                <div class="modal-col">
                    <button type="button" class="btn gray-btn" (click)="selectLens(linedBifocalLens)">No</button>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="showProgressiveOptions">
        <div class="modal-row">
            <h5>Please select a progressive lens</h5>
        </div>
        <div class="modal-row">
            <ng-container *ngFor="let lens of orderedProgLenses; index as i">
                <ng-container [ngSwitch]="i">
                    <div class="modal-col">
                        <img *ngSwitchCase="'0'" src="../../../../assets/images/guided-opt/progAveragev2.jpg">
                        <img *ngSwitchCase="'1'" src="../../../../assets/images/guided-opt/progGoodv2.jpg">
                        <img *ngSwitchCase="'2'" src="../../../../assets/images/guided-opt/progUltimatev2.jpg">
                        <span>{{lens.lensName}}</span>
                        <button type="button" class="btn gray-btn" (click)="selectLens(lens)">+{{lens.price | currency}}</button>
                    </div>                 
                </ng-container>
            </ng-container> 
        </div>
    </ng-container>
    <!--  Bifocal / Progressive Selection Screen -->
</ng-template>